'use client';

import { useState, useEffect } from 'react';
import IntroPopup, { PopupData } from './IntroPopup';

export default function IntroPopupWrapper() {
  const [popups, setPopups] = useState<PopupData[]>([]);
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // 사용자가 팝업 닫기 버튼 클릭 시에만 시간 저장하는 로직으로 변경
  const checkPopupShouldShow = () => {
    if (typeof window === 'undefined') return false;
    
    const lastClosedTimestamp = localStorage.getItem('lastClosedPopups');
    const now = Date.now();
    
    // 마지막으로 팝업을 닫은 시간이 없거나, 24시간이 지났으면 팝업을 보여줌
    return !lastClosedTimestamp || (now - parseInt(lastClosedTimestamp)) > 24 * 60 * 60 * 1000;
  };

  useEffect(() => {
    const fetchPopups = async () => {
      try {
        setLoading(true);
        console.log('팝업 API 호출 시작');
        const response = await fetch('/api/popup');
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('팝업 API 오류:', response.status, errorText);
          throw new Error(`팝업 데이터를 불러오는데 실패했습니다. 상태코드: ${response.status}`);
        }
        
        const data = await response.json();
        console.log('팝업 데이터:', data);
        
        if (data.popups && data.popups.length > 0) {
          const sortedPopups = [...data.popups].sort((a, b) => a.order - b.order);
          setPopups(sortedPopups);
          
          // 새로고침 시에도 팝업을 보여주기 위해 마지막 닫기 시간을 확인
          const shouldShow = checkPopupShouldShow();
          setShowPopup(shouldShow);
          
          // 팝업 아이디 기록 (통계 또는 추후 활용을 위해)
          const popupIds = sortedPopups.map(popup => popup.id);
          localStorage.setItem('availablePopups', JSON.stringify(popupIds));
        }
      } catch (err: any) {
        console.error('팝업을 불러오는 중 오류 발생:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPopups();
  }, []); // 빈 의존성 배열로 초기 로드 시에만 실행

  const handleClose = () => {
    setShowPopup(false);
    
    // 사용자가 직접 팝업을 닫은 경우에만 현재 시간을 저장
    localStorage.setItem('lastClosedPopups', Date.now().toString());
  };

  if (loading || error || !showPopup || popups.length === 0) {
    return null;
  }

  return <IntroPopup popups={popups} onClose={handleClose} />;
}
